import React from 'react';

const RadioTechno = () => (
  <div className="container mt-4">
    <h1>Techno Radio</h1>
    <p>Techno beats are on now.</p>
  </div>
);

export default RadioTechno;
